<template>
    <div class="">
        <a href="#" class="btn btn-sm btn-light" @click.prevent="handleModal"  data-toggle="tooltip" data-placement="left" :title="title">
            <i aria-hidden="true" class="fa fa-trash"></i>
        </a>

        <Modal v-if="! warning" :title="title" :show="showModal" @close="showModal = false">
            <form :action="route" method="POST">
                <input type="hidden" name="_method" value="DELETE" />
                <input type="hidden" name="_token" :value="csrfToken" />
                <input v-if="tabIdentifier" type="hidden" name="tab_identifier" :value="tabIdentifier" />
                <p v-html="message"></p>
                <button class="btn btn-primary" type="submit" ref="submitRef">Submit</button>
                <button class="btn btn-link" @click.prevent="showModal = false">Close</button>
            </form>
        </Modal>

        <Modal v-if="warning" :title="title" :show="showModal" @close="showModal = false">
            <p class="text-danger" v-html="warning"></p>
            <button class="btn btn-primary" @click.prevent="showModal = false">Close</button>
        </Modal>
    </div>
</template>

<script>
import Modal from "./Modal";

export default {
    name: "DeleteModal",
    props: {
        message: { type: String, default: '', required: false },
        route: { type: String, required: true },
        title: { type: String, default: 'Delete', required: false },
        tabIdentifier: { type: String, default: '', required: false },
        warning: { type: String, default: '', required: false}
    },
    components: {
        Modal,
    },
    data() {
        return {
            showModal: false,
            csrfToken: '',
        };
    },
    methods: {
        handleModal() {
            this.showModal = true;

            if(!this.warning) {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.submitRef.focus();
                    });
                });
            }
        },
    },
    mounted() {
        this.csrfToken = $('[name="csrf-token"]').attr('content');
    },
}
</script>